import { IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";

const CustomIconButton = styled(IconButton)(({ theme }) => ({
  background: "#ffffff",
  border: `1px solid ${theme.palette.common.border}`,
  borderRadius: 8,
  height: 44,
  width: 44,
  [`&:hover`]: {
    background: "#e8e8e8",
    borderColor: "#e8e8e8",
  },
}));

export default CustomIconButton;
